var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSemiGantry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 840 840",
    style: {
      enableBackground: "new 0 0 840 840"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,274c0-17.5,14.1-31.6,31.6-31.6h716.8c17.5,0,31.6,14.2,31.6,31.6v31.6c0,7-5.7,12.6-12.6,12.6H35.6 c-7,0-12.6-5.7-12.6-12.6V274z M60.9,349.1c0-7,5.7-12.6,12.6-12.6h50.6c7,0,12.6,5.7,12.6,12.6v31.6c0,14.8-10.1,27.1-23.8,30.6 V741v11v16c0,4.4-3.6,8-8,8H31c-4.4,0-8-3.6-8-8v-27c0-4.4,3.6-8,8-8h54V411.4c-13.8-3.4-24.1-15.8-24.1-30.7V349.1z M221.3,336.4 c-3.5,0-6.3,2.8-6.3,6.3v19c0,3.4,2.7,6.2,6,6.3l37.5,93.5c-11,7.2-18.2,19.6-18.2,33.7c0,18.6,12.5,34.2,29.6,38.9v1 c0,5.6-2.2,10.9-6.1,14.8l-7,7c-14.2,14.2-14.2,37.3,0,51.5c14.2,14.2,37.2,14.2,51.4,0l3-3c12.6-12.6,12.6-33,0-45.5l-17.9,17.9 c2.7,2.7,2.7,7.1,0,9.8l-3,3c-4.3,4.3-11.4,4.3-15.7,0c-4.3-4.3-4.3-11.4,0-15.7l7-7c8.7-8.7,13.5-20.4,13.5-32.7v-2.3 c15-5.9,25.7-20.5,25.7-37.6c0-14-7.1-26.3-17.9-33.5L341,368c3.3-0.2,5.8-3,5.8-6.3v-8.1v-10.9c0-3.5-2.8-6.3-6.3-6.3H221.3z  M280.7,441.3L251.4,368h59.2L280.7,441.3z M137,213.3c0,7-5.7,12.7-12.7,12.7H73.7c-7,0-12.7-5.7-12.7-12.7v-31.7 c0-17.5,14.2-31.7,31.7-31.7h12.7c17.5,0,31.7,14.2,31.7,31.7V213.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiGantry);
export default __webpack_public_path__ + "static/media/semi-gantry.7083742c34aaebd630cce4649af2dd8b.svg";
export { ForwardRef as ReactComponent };